"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JwtHighbondClient = void 0;
const config_1 = require("./config");
class JwtHighbondClient {
    constructor(config = {}) {
        this.config = { ...config_1.Config, ...config };
    }
    async fetchWithTokenRefresh(requestInfo, requestOptions) {
        let response = await fetch(requestInfo, requestOptions);
        if (response.status === 401) {
            let hostname = window.location.hostname;
            let subdomain = hostname === 'localhost' ? hostname : hostname.split('.').reverse()[3]; // eg [com, highbond, toolkits, myorg] - hostParts[3] will hold org/subdomain
            let refreshPromise = this.putWithCredentials(this.config.tokenRefreshUrl);
            let refreshSubdomainPromise = this.config.noSubdomain
                ? Promise.resolve()
                : this.putWithCredentials(`${this.config.tokenRefreshUrl}?org_subdomain=${subdomain}`);
            refreshSubdomainPromise.catch(() => {
                // To avoid UnhandledPromiseRejectionWarning if refreshSubdomainPromise rejects before refreshPromise resolves.
            });
            try {
                await refreshPromise;
            }
            catch {
                if (this.config.autoRedirect) {
                    window.location.href = `${this.config.loginUrl}?redirect_uri=${window.location.href}`;
                }
                return response;
            }
            try {
                await refreshSubdomainPromise;
            }
            catch {
                if (this.config.autoRedirect) {
                    // If subdomain refresh fails we don't redirect back
                    window.location.href = this.config.loginUrl;
                }
                return response;
            }
            return await fetch(requestInfo, requestOptions);
        }
        else {
            // if there was no 401 - returning original response
            return response;
        }
    }
    async putWithCredentials(url) {
        let response = await fetch(url, {
            method: 'PUT',
            credentials: 'include',
        });
        if (!response.ok) {
            throw new Error(response.statusText);
        }
    }
}
exports.JwtHighbondClient = JwtHighbondClient;
//# sourceMappingURL=index.js.map